import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import MaskedInput from 'react-text-mask';
import Tooltip from '../Tooltip';
import './style.css';

const Input = (props) => {
  const [isFocused, setIsFocused] = useState(false);
  const [isRequiredInternal, setIsRequiredInternal] = useState(false);
  const { label, tooltip, className, labelClass, errorMessage, value, offset, isMasked, isDisabled, hasError, placeHolder, isRequired, onChange, ...restProps } = props;

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = (e) => {
    const { value: targetValue } = e.target;
    if (targetValue) {
      setIsRequiredInternal(false);
    } else {
      setIsRequiredInternal(isRequired);
    }
    !isRequired && setIsFocused(false);
  };

  return (
    <div
      className={cn({
        'has-value': isFocused || value.length || hasError || isRequired,
        active: (isFocused || value.length || isRequired),
        required: !isDisabled && ((isRequiredInternal && !value.length) || hasError),
        disabled: isDisabled,
      }, 'form-group', 'inputWrapper')}
    >
      <label className={labelClass}>
        <span>
          {label}
          {
            isRequired && (
              <em>
                {isRequired && hasError !== 'The input field is required' && hasError && 'Error'}
                {!isRequired && hasError !== 'The input field is required' && hasError && 'Error'}
                {isRequired && (hasError === 'The input field is required' || !hasError) && 'Required'}
              </em>
            )
          }
        </span>
        {
          isMasked ? (
            <MaskedInput
              className={className}
              value={value}
              mask={isMasked}
              disabled={isDisabled}
              placeholder={(isFocused || value.length || isDisabled || hasError) ? placeHolder : ''}
              onFocus={handleFocus}
              onBlur={handleBlur}
              onChange={onChange}
              {...restProps}
            />
          ) : (
            <input
              className={className}
              value={value}
              disabled={isDisabled}
              placeholder={(isFocused || value.length || isDisabled || hasError) ? placeHolder : ''}
              onFocus={handleFocus}
              onBlur={handleBlur}
              onChange={onChange}
              {...restProps}
            />
          )
        }
        {errorMessage && errorMessage !== 'The input field is required' ? <div className="errorMessage">{errorMessage}</div> : null}
      </label>
      {tooltip && <Tooltip offset={offset}>{tooltip}</Tooltip>}
    </div>
  );
};

Input.propTypes = {
  label: PropTypes.string.isRequired,
  hasError: PropTypes.bool,
  tooltip: PropTypes.any,
  isDisabled: PropTypes.bool,
  value: PropTypes.string,
  className: PropTypes.string,
  isMasked: PropTypes.any,
  placeHolder: PropTypes.string,
  onChange: PropTypes.func,
  offset: PropTypes.number,
  errorMessage: PropTypes.string,
  labelClass: PropTypes.string,
  isRequired: PropTypes.bool,
};

Input.defaultProps = {
  className: '',
  labelClass: '',
  value: '',
  isDisabled: false,
  hasError: false,
  placeHolder: '',
  isMasked: false,
  onChange: () => {},
  tooltip: '',
  offset: 1,
  isRequired: false,
  errorMessage: '',
};

export default Input;
